import { initInterview } from "../../assets/variables/inits/interview.inits";
import { INTERVIEW_VIEW } from "./interview.const";

/**
 * @param {InterviewState|undefined} state
 * @returns {InterviewState}
 */
export function initInterviewState(state = {}) {
    return {
        ...(state || {}),

        code: state?.code || null,
        data: state?.data || null,
        view: INTERVIEW_VIEW.JOIN.value,

        loading: state?.loading || false,
    };
}

/**
 * @typedef InterviewState
 * @property {string}           code 면접코드
 * @property {string}           view 화면상태
 * @property {InterviewModel}   data 화면상태
 * @property {boolean}          loading 로딩여부
 */

/**
 * @typedef {ReturnType<typeof initInterview>|undefined} InterviewModel
 */
